import { DefaultValueWhenCreate, FieldBizType, FieldDBType } from '../_constants/field';
import { getQuoteByFieldType } from './field';
import { get } from './util';
export var spliceInsertSQL = function (params) {
    var entity = params.entity, conAry = params.conAry, isEdit = params.isEdit, genUniqueId = params.genUniqueId, encrypt = params.encrypt, data = params.data, batch = params.batch;
    // const sql = `INSERT INTO ${entity.name}${isEdit ? '' : '__VIEW'} `;
    var sql = "INSERT INTO ".concat(entity.id, " ");
    var res = [];
    var fieldAry = entity.fieldAry.filter(function (field) { return (field.bizType !== FieldBizType.MAPPING); }).filter(function (field) { return (field.isPrimaryKey ? field.extra !== 'auto_increment' : true); }).map(function (field) { return field.name; });
    (batch ? data : [data]).forEach(function (item) {
        var valueAry = [];
        entity.fieldAry.forEach(function (field) {
            if (field.bizType !== FieldBizType.MAPPING) {
                var con = conAry.find(function (con) { return con.to === "/".concat(field.name); });
                if (con) {
                    /** 多级结构 */
                    var fromNames = con.from.split('/').filter(Boolean);
                    var value = get(item, fromNames.map(function (key) { return key; }));
                    var q = getQuoteByFieldType(field.dbType);
                    if (value === undefined || value === null) {
                        valueAry.push('null');
                    }
                    else if (Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]') {
                        valueAry.push("".concat(q).concat(JSON.stringify(field.useEncrypt ? encrypt(value) : value)).concat(q));
                    }
                    else {
                        valueAry.push("".concat(q).concat(field.useEncrypt ? encrypt(value) : value).concat(q));
                    }
                }
                else {
                    if (field.isPrimaryKey) {
                        if (field.extra !== 'auto_increment') {
                            valueAry.push(String(genUniqueId()));
                        }
                    }
                    else if (field.name === '_STATUS_DELETED') {
                        valueAry.push('0');
                    }
                    else if (['_UPDATE_TIME', '_CREATE_TIME'].includes(field.name)
                        || (field.bizType === FieldBizType.DATETIME && field.defaultValueWhenCreate === DefaultValueWhenCreate.CURRENT_TIME)) {
                        valueAry.push(String(Date.now()));
                    }
                    else if (field.defaultValueWhenCreate !== undefined && field.defaultValueWhenCreate !== null) {
                        var q = getQuoteByFieldType(field.dbType);
                        valueAry.push("".concat(q).concat(field.useEncrypt ? encrypt(field.defaultValueWhenCreate) : field.defaultValueWhenCreate).concat(q));
                    }
                    else {
                        if (!field.notNull) {
                            valueAry.push('default');
                        }
                        else {
                            valueAry.push('null');
                        }
                    }
                }
            }
        });
        res.push(valueAry);
    });
    return "".concat(sql, "(").concat(fieldAry.join(','), ") VALUES ").concat(res.map(function (valueAry) { return "(".concat(valueAry.join(','), ")"); }).join(', '));
};
export var validateParams = function (data, entity, conAry, isInsert) {
    var _a;
    if (isInsert === void 0) { isInsert = true; }
    var values = Array.isArray(data) ? data : [data];
    var fieldAry = entity.fieldAry.filter(function (field) { return conAry.find(function (con) { return con.to === "/".concat(field.name); }); });
    for (var i = 0; i < values.length; i++) {
        var params = values[i];
        var _loop_1 = function (j) {
            var field = fieldAry[j];
            var con = conAry.find(function (con) { return con.to === "/".concat(field.name); });
            if (!con) {
                return "continue";
            }
            var paramKeys = con.from.substring(con.from.indexOf('/') + 1).split('/');
            var curValue = get(params, paramKeys);
            if (curValue === undefined || curValue === null) {
                /** 新建场景下，字段设置不能为空，且没有默认值 */
                if (isInsert && field.notNull && !field.defaultValueWhenCreate) {
                    throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 不能为空');
                }
                else if (!isInsert && field.notNull && curValue === null) {
                    /** 更新场景下，字段设置不能为空，且值为 null */
                    throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 不能为空');
                }
                else {
                    return "continue";
                }
            }
            /** 字符类型校验 */
            if ((field.dbType === FieldDBType.VARCHAR || field.dbType === FieldDBType.MEDIUMTEXT)
                && field.bizType !== FieldBizType.ENUM
                && field.bizType !== FieldBizType.JSON
                && typeof curValue !== 'string'
                && typeof curValue !== 'number') {
                throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 必须为字符串或数字类型');
            }
            /** 数字类型校验 */
            if (field.dbType === FieldDBType.BIGINT && typeof curValue !== 'number' && parseInt(curValue) != curValue) {
                throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 必须为数字类型');
            }
            /** 枚举值校验 */
            if (field.bizType === FieldBizType.ENUM) {
                var enumValues = (_a = field.enumValues) !== null && _a !== void 0 ? _a : [];
                if (enumValues.length) {
                    var parsedValue = curValue;
                    try {
                        parsedValue = JSON.parse(parsedValue);
                    }
                    catch (e) { }
                    if (Array.isArray(parsedValue)) {
                        for (var enumIndex = 0; enumIndex < parsedValue.length; enumIndex++) {
                            if (!enumValues.includes(parsedValue[enumIndex])) {
                                throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 中每一项必须为枚举值 ' + enumValues.join('/') + ' 其中之一');
                            }
                        }
                    }
                    else if (!enumValues.includes(String(parsedValue))) {
                        throw new Error('请求参数字段 ' + paramKeys.join('.') + ' 必须为枚举值 ' + enumValues.join('/') + ' 其中之一');
                    }
                }
            }
        };
        for (var j = 0; j < fieldAry.length; j++) {
            _loop_1(j);
        }
    }
};
